import { Outlet, ScrollRestoration } from "react-router-dom";
import { LogoIntro } from "@/components/LogoIntro";
import { Footer } from "@/components/layout/Footer";
import { Navbar } from "@/components/layout/Navbar";
import { ScrollToTop } from "@/components/layout/ScrollToTop";

export function PublicLayout() {
  return (
    <div className="relative min-h-screen overflow-x-hidden">
      <div className="cyber-grid pointer-events-none absolute inset-0 opacity-60" />
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-cyan-300 to-transparent" />
      <div className="relative flex min-h-screen flex-col">
        <ScrollToTop />
        <LogoIntro />
        <Navbar />
        <main className="min-w-0 flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
      <ScrollRestoration />
    </div>
  );
}
